var _defs, _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 33",
    width: 36,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 38,
    height: 22,
    id: "img1",
    href: "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTguNTc2IiBoZWlnaHQ9IjEwLjkxNCIgdmlld0JveD0iMCAwIDE4LjU3NiAxMC45MTQiPgogIDxnIGlkPSJpY29uX1ZpZGVvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC05Ni41MTIpIj4KICAgIDxnIGlkPSJHcm91cF8zNDM3MyIgZGF0YS1uYW1lPSJHcm91cCAzNDM3MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA5Ni41MTIpIj4KICAgICAgPGcgaWQ9Ikdyb3VwXzM0MzcyIiBkYXRhLW5hbWU9Ikdyb3VwIDM0MzcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj4KICAgICAgICA8cGF0aCBpZD0iUGF0aF80MDM5NSIgZGF0YS1uYW1lPSJQYXRoIDQwMzk1IiBkPSJNMTAuNTA4LDk2LjUxMkgyLjAzMkEyLjAzOCwyLjAzOCwwLDAsMCwwLDk4LjU0NHY2Ljg0OWEyLjAzOCwyLjAzOCwwLDAsMCwyLjAzMiwyLjAzMmg4LjQ3NWEyLjAzOCwyLjAzOCwwLDAsMCwyLjAzMi0yLjAzMlY5OC41NDRBMi4wMjUsMi4wMjUsMCwwLDAsMTAuNTA4LDk2LjUxMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTk2LjUxMikiIGZpbGw9IiNmZmYiLz4KICAgICAgPC9nPgogICAgPC9nPgogICAgPGcgaWQ9Ikdyb3VwXzM0Mzc1IiBkYXRhLW5hbWU9Ikdyb3VwIDM0Mzc1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy41NTYgOTcuNTk3KSI+CiAgICAgIDxnIGlkPSJHcm91cF8zNDM3NCIgZGF0YS1uYW1lPSJHcm91cCAzNDM3NCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfNDAzOTYiIGRhdGEtbmFtZT0iUGF0aCA0MDM5NiIgZD0iTTM0NS4wMiwxMjMuODhhMS4wMzUsMS4wMzUsMCwwLDAtLjM0NS4xNDJsLTMuMTcxLDEuODI5djQuNzE1bDMuMTkxLDEuODI5YTEuMjA4LDEuMjA4LDAsMCwwLDEuNjY3LS40NDcsMS4yNDEsMS4yNDEsMCwwLDAsLjE2My0uNjF2LTYuMjhBMS4yMjMsMS4yMjMsMCwwLDAsMzQ1LjAyLDEyMy44OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNDEuNTA0IC0xMjMuODQ3KSIgZmlsbD0iI2ZmZiIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "file-video",
    href: "#img1",
    transform: "matrix(.534,0,0,.554,7.847,10.908)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileVideo);
export default __webpack_public_path__ + "static/media/file-video.6c761ca2.svg";
export { ForwardRef as ReactComponent };